import React, { useState } from 'react';
import { InputBase } from '@material-ui/core';
import { borderColor } from './common';

const EAA_Memo = ({ disabled = false, displayBorder = false, value = '', hint = '請輸入', onChange = () => {}, marginRight = 50, id = null }) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  return (
    <div style={{ flex: 1, marginRight }}>
      <InputBase
        id={id}
        readOnly={disabled}
        style={{
          backgroundColor: disabled ? '#ededed' : 'white',
          width: '100%',
          minHeight: 70,
          fontSize: 16,
          letterSpacing: '0.15px',
          borderRadius: 14,
          paddingLeft: 12,
          alignItems: 'start',
          border: ((displayBorder || over || focus) && !disabled) ? `1px solid ${(over || focus) ? 'black' : borderColor}` : '',
        }}
        placeholder={hint}
        inputProps={{ height: 44 }}
        onChange={e => onChange(e.target.value)}
        rowsMax={10}
        multiline
        value={value}
        onMouseOver={() => setOver(true)}
        onMouseOut={() => setOver(false)}
        onBlur={() => setFocus(false) }
        onFocus={() => setFocus(true)}
      />
    </div>
  );
};

export default EAA_Memo;
